import { FetchUserAttributesOutput } from 'aws-amplify/auth';

export type PostAuthRedirectPath = '/dashboard' | '/terms';

export function getPostAuthRedirectPath(
  attributes?: FetchUserAttributesOutput | null
): PostAuthRedirectPath {
  return attributes?.['custom:terms_ok'] === 'true' ? '/dashboard' : '/terms';
}
